import { createHeader } from '@zoom/common-header'
import '@zoom/common-header/style.css'

import { getContext } from '../../../commons/portal-init/get-context'
import { DOM_IDS } from './constants.js'
import { getLogoMainText } from './config.js'
import { normalizeHeader } from './header-config.js'
import { buildHeaderOptions } from './header-options.js'
import { applyHeaderTheme } from './theme.js'
import { createMobileWatcher } from './responsive.js'
import { maybeRunCoachMark } from './coach-mark.js'
import { mountLeftSlots } from './sub-apps/mount-left-slots.js'
import { mountRightSlots } from './sub-apps/mount-right-slots.js'
import { mountBillingCart } from './sub-apps/mount-billing-cart.js'
import { mountMobileToggle, unmountMobileToggle } from './sub-apps/mount-mobile-toggle.js'

export default function initCommonHeader(rawConfig) {
  const ctx = getContext()
  const header = normalizeHeader(rawConfig)
  const logoText = getLogoMainText(ctx)

  ;(async () => {
    const options = buildHeaderOptions({
      ctx,
      header,
      logoText,
      rawConfig,
      onProfileMenuReady: (_, userInfo) => mountRightSlots({ ctx, header, userInfo })
    })

    const instance = await createHeader(`#${DOM_IDS.HEADER_CONTAINER}`, options)
    window.commonHeader = instance
    void mountBillingCart()

    await mountLeftSlots({ ctx, header })

    if (ctx.useSimplifiedHeaderRaw) return

    await maybeRunCoachMark({ ctx })

    createMobileWatcher({
      onEnter: mountMobileToggle,
      onLeave: unmountMobileToggle
    }).start()

    applyHeaderTheme(header.style)
  })().catch((err) => {
    console.error('[common-header] Init failed:', err)
  })
}
